import { updateQueryStringParam } from '../helpers/edit_query_string.js';

$(document).ready(function(){
  // search.html.erb
  var stickyTabs = $('.js-search-tab-bar');
  if (stickyTabs.length > 0) {
    var stickyFilters = $('.js-search-filters');
    var placeholder = $('.js-search-tab-bar-placeholder');
    var footer = $('.js-search-footer');
    var $window = $(window);

    var stickyTabsOffset = stickyTabs.offset().top;
    var stickyTabsOuterHeight = stickyTabs.outerHeight(true);
    var stickyTabsHeight = stickyTabs.height();
    var stickyFiltersHeight = stickyFilters.height();
    var stickyFiltersOffset = 148; // Hardcoding because when on small screen the filters are hidden and this would be 0
    var stickyFiltersTopPadding = 48; // Linked to the padding-top in de stylesheet! (16px padding + 32px the filters are above the tabs)

    var stickyTabsClassName = 'dc-global-search__tabs--sticky';
    var stickyFiltersClassName = 'dc-global-search__filters--sticky';

    stickyFilters.css({ top: ('' + stickyTabsHeight + 'px') });

    function checkScroll() {
      // for the tabs
      if ($window.scrollTop() >= stickyTabsOffset) {
        if(!stickyTabs.hasClass(stickyTabsClassName)){
          stickyTabs.addClass(stickyTabsClassName);
          placeholder.height(stickyTabsOuterHeight);
        }
      }
      else {
        stickyTabs.removeClass(stickyTabsClassName);
        placeholder.height(0);
      }

      // for the filters
      if ($window.scrollTop() >= (stickyTabsOffset - stickyFiltersTopPadding)) {
        if(!stickyFilters.hasClass(stickyFiltersClassName)) {
          stickyFilters.addClass(stickyFiltersClassName);
        }
      }
      else {
        stickyFilters.removeClass(stickyFiltersClassName);
      }

      /* to not scroll over the footer

      a bit of explanation:
      We take the current top of the page +
      the height of the filters block +
      the inital offset of the filterblock -
      the height of the tab bar which we already set in the top property off the filters

      and compare that with the offset of the footer
      */
      var footerOffset = footer.offset().top;

      if ($window.scrollTop() + stickyFiltersHeight + stickyFiltersOffset - stickyTabsHeight >= footerOffset) {
        stickyFilters.css({marginTop: footerOffset - ($window.scrollTop() + stickyFiltersHeight + stickyFiltersOffset - stickyTabsHeight)});
      } else {
        stickyFilters.css({marginTop: 0});
      }
    }

    checkScroll();
    $window.on("scroll", checkScroll);
    $window.on("resize",checkScroll);
  }

  // To change the url params when the tabs change
  $('.js-search-tab-bar a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    var target = $(e.target).attr("href") // activated tab
    var tabValue = target.slice(1) // delete the first character because it is a #
    updateQueryStringParam('tab', tabValue) // update tab in the URL
    $('.js-search-filters-form-tab-input').val(tabValue) // update tab in the form for the filters
    $('.js-navbar-search').data('redirect_to_tab', tabValue) // update tab so it sticks with another search term
  });
});
